import { __assign } from 'tslib';
import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ElementSummary";
var classes = {
    imageContainer: "".concat(PREFIX, "-imageContainer"),
    image: "".concat(PREFIX, "-image"),
    topLeftElement: "".concat(PREFIX, "-topLeftElement"),
    topRightElement: "".concat(PREFIX, "-topRightElement"),
    bottomLeftElement: "".concat(PREFIX, "-bottomRightElement"),
    iconOverMedia: "".concat(PREFIX, "-iconOverMedia")
};
var StyledElementCardMedia = styled(Card, {
    shouldForwardProp: function (prop) {
        return prop !== "allowNavigation" &&
            prop !== "listViewSize" &&
            prop !== "dataviewType" &&
            prop !== "showFields" &&
            prop !== "useImgComponent";
    }
})(function (_a) {
    var _b;
    var theme = _a.theme, allowNavigation = _a.allowNavigation, useImgComponent = _a.useImgComponent, showFields = _a.showFields;
    return (__assign(__assign({ position: "relative" }, (!useImgComponent && { borderBottom: "1px solid ".concat(theme.palette.background.paper) })), (_b = { boxShadow: "none", borderRadius: 0, "& .MuiCardMedia-root": __assign(__assign(__assign({}, (!useImgComponent && {
                height: 0,
                paddingTop: "100%"
            })), (useImgComponent && {
                padding: 0,
                border: 0
            })), { cursor: allowNavigation ? "pointer" : "default" }) }, _b["& .".concat(classes.image)] = {
        appearance: "none",
        outline: "none",
        width: "100%",
        border: "none",
        position: "relative",
        overflow: "hidden",
        "& img": {
            objectFit: "contain",
            width: "100%"
        },
        "&:focus": {
            filter: "brightness(0.8)"
        }
    }, _b["& .".concat(classes.topLeftElement)] = {
        position: "absolute",
        // child element is responsible of margins for full layout control
        top: 0,
        left: 0,
        width: "100%"
    }, _b["& .".concat(classes.topRightElement)] = {
        position: "absolute",
        // child element is responsible of margins for full layout control
        top: 0,
        right: 0,
        width: "100%"
    }, _b["& .".concat(classes.bottomLeftElement)] = __assign({ position: "absolute", bottom: "10px", left: "0%" }, (!showFields && {
        left: "5px"
    })), _b["& .".concat(classes.iconOverMedia)] = {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
    }, _b)));
});

export { classes, StyledElementCardMedia as default };
//# sourceMappingURL=index.styled.js.map
